import { graphql } from "@/data-access/graphql";
import { ShareVoiceSegmentFragment } from "../fragments/segment-fragment";

export const CreateShareVoiceSegment = graphql(
  `
 mutation createShareVoiceSegment($input: ShareVoiceSegmentInput!) {
  createShareVoiceSegment(input: $input) {
    ... on ShareVoiceSegmentType {
      ...ShareVoiceSegmentFragment
    }
  }
 }
`,
  [ShareVoiceSegmentFragment],
);

export const GetShareVoiceSegments = graphql(
  `
 query getShareVoiceSegments {
  shareVoiceSegments(ordering: [{ visible: DESC }, { order: ASC }, { name: ASC }] ) {
    ...ShareVoiceSegmentFragment
  }
 }
`,
  [ShareVoiceSegmentFragment],
);

export const UpdateShareVoiceSegment = graphql(
  `
 mutation updateShareVoiceSegment($input: ShareVoiceSegmentUpdateInput!) {
  updateShareVoiceSegment(input: $input) {
    ...ShareVoiceSegmentFragment
  }
}
`,
  [ShareVoiceSegmentFragment],
);

export const DeleteShareVoiceSegment = graphql(
  `
  mutation deleteShareVoiceSegment($input: DeleteShareVoiceSegmentInput!) {
    deleteShareVoiceSegment(input: $input) {
      ... on ShareVoiceSegmentType {
        ...ShareVoiceSegmentFragment
      }
      ... on OperationInfo {
        messages {
          kind
          message
          field
          code
        }
      }
    }
  }
  `,
  [ShareVoiceSegmentFragment],
);
